import script from "./BackToTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BackToTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./BackToTopComponent.vue?vue&type=style&index=0&id=2bba385c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bba385c"]])

export default __exports__